import { render, staticRenderFns } from "./RecoveryRequest.vue?vue&type=template&id=3c1d1856&scoped=true&"
import script from "./RecoveryRequest.vue?vue&type=script&lang=js&"
export * from "./RecoveryRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1d1856",
  null
  
)

export default component.exports